import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import {
  FiGrid,
  FiChevronLeft,
  FiChevronRight,
  FiMonitor,
  FiLogOut
} from 'react-icons/fi';
import { IoMdCube } from 'react-icons/io';
import { authService } from '../services/authService';

const Layout = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const handleLogout = () => {
    authService.logout();
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <div className={`bg-white border-r border-gray-200 transition-all duration-300 relative ${collapsed ? 'w-20' : 'w-60'}`}>
        <div className="p-4 flex items-center justify-center">
          <div className="flex items-center">
            <img
              src="/favicon.png"
              alt="ARMS Logo"
              className={`${collapsed ? 'w-8 h-8' : 'w-10 h-10'} object-contain`}
            />
            {!collapsed && (
              <span className="ml-2 font-dm-serif text-gray-800 text-2xl">
                ARMS
              </span>
            )}
          </div>
        </div>

        <nav className="mt-6">
          <Link to="/dashboard"
            className={`py-3 px-4 flex items-center ${isActive('/dashboard') ?
              'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'}`}>
            <FiGrid className={`${collapsed ? 'mx-auto' : 'mr-3'}`} size={20} />
            {!collapsed && <span>Dashboard</span>}
          </Link>

          <Link to="/projects"
            className={`py-3 px-4 flex items-center ${isActive('/projects') ?
              'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'}`}>
            <IoMdCube className={`${collapsed ? 'mx-auto' : 'mr-3'}`} size={20} />
            {!collapsed && <span>Projects</span>}
          </Link>

          <Link to="/system-resources"
            className={`py-3 px-4 flex items-center ${isActive('/system-resources') ?
              'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'}`}>
            <FiMonitor className={`${collapsed ? 'mx-auto' : 'mr-3'}`} size={20} />
            {!collapsed && <span>System Resources</span>}
          </Link>




        </nav>

        {/* User Actions */}
        <div className="absolute bottom-4 left-0 w-full px-4">
          <button
            onClick={handleLogout}
            className={`w-full py-3 px-4 flex items-center justify-center text-red-500 hover:bg-red-50 hover:text-red-600 transition-colors rounded-lg border border-transparent hover:border-red-100 ${collapsed ? '' : 'justify-start'}`}
          >
            <FiLogOut className={`${collapsed ? 'mx-auto' : 'mr-3'}`} size={20} />
            {!collapsed && <span className="font-medium tracking-wide">Logout</span>}
          </button>
        </div>

        {/* Sidebar collapse/expand button */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="absolute -right-3 top-20 bg-white border border-gray-200 rounded-full p-1 text-gray-500 hover:text-gray-700 shadow-sm"
        >
          {collapsed ? <FiChevronRight size={16} /> : <FiChevronLeft size={16} />}
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white border-b border-gray-200 h-16 flex items-center px-6 justify-between">
          <h1 className="text-xl font-semibold text-gray-700">
            {location.pathname.includes('/dashboard') && 'Dashboard'}
            {location.pathname === '/projects' && 'Projects'}
            {location.pathname.includes('/projects/') && !location.pathname.includes('/runhistory') && <span className="font-bold">PROJECT DETAILS</span>}
            {location.pathname.includes('/runhistory') && 'Run History'}
            {location.pathname.includes('/system-resources') && 'System Resources'}
            {location.pathname.includes('/cost-analytics') && 'Cost Analytics'}
            {location.pathname.includes('/query-analytics') && 'Query Analytics'}
            {location.pathname.includes('/log-analytics') && 'Log Analytics'}


          </h1>
        </header>
        <main className="flex-1 overflow-y-auto p-6 bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 